import { LANGUAGE_CHANGE } from './languageActions'

import { Map } from 'immutable'

const INITIAL_STATE = Map({
    current: Map(),
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LANGUAGE_CHANGE:
            return state.set('current', state.get('current').merge(action.language))
        default:
            return state
    }
}
